import mixpanel from "mixpanel-browser";

const registerAnalyticsGroup = async company => {
  if (!company.company) {
    return;
  }

  const {
    id: company_id,
    parent: parent_company_id,
    is_paying,
    is_testing,
    is_agency
  } = company.company;

  mixpanel.set_group("company_id", company_id);
  mixpanel.get_group("company_id", company_id).set({
    $name: `${company_id}_${company.company.name}`,
    parent_company_id: company.company.parent || company_id,
    company_id,
    raw_name: company.company.name,
    is_paying,
    is_testing,
    is_agency
  });

  if (parent_company_id && company.parent) {
    const { parent } = company;
    const parentName = parent.name;
    const is_paying = parent.is_paying;
    const is_testing = parent.is_testing;
    const is_agency = parent.is_agency;

    mixpanel.set_group("parent_company_id", parent_company_id);
    mixpanel.get_group("parent_company_id", parent_company_id).set({
      name: `${parent_company_id}_${parentName}`,
      parent_company_id: parent_company_id,
      company_id: parent_company_id,
      raw_name: parentName,
      is_paying,
      is_testing,
      is_agency
    });
  }
};

export default registerAnalyticsGroup;
